module.exports = __webpack_public_path__ + "img/05侯艳伟.ed0b2575.jpg";